import { PanelResultDetails } from "../../store/slices/order/types";
import { formatCultureResultData } from "../../utils/result.utils";

const CultureResult = ({
  resultDetails,
}: {
  resultDetails: PanelResultDetails;
}) => {
  const organismResults = formatCultureResultData(resultDetails?.strValue);
  return (
    <tr className="p-4 bg-[#F4F6F8] mb-24">
      {organismResults.map((organism, index) => (
        <div key={index} className="">
          <div className="bg-white p-4 border-b border-b-[#E7E9EB] my-4">
            <p className="text-left text-[15px] font-[500]">
              {resultDetails?.name}
            </p>
          </div>
          <div className="text-left sm:flex sm:flex-row sm:justify-between sm:items-center bg-[#0C4654] font-[500] text-white py-4 px-4">
            <p>Organism: {organism?.name}</p>
            <p>Growth: {organism?.growth?.toUpperCase()}</p>
          </div>
          <div className="w-full">
            <table className="w-full bg-white border-collapse shadow-sm text-center">
              <thead className="border">
                <th className="border w-1/2 font-[600] p-4">Antibiotics</th>
                <th className="border w-1/2 font-[600] p-4 text-[0.875rem] sm:text-[1rem]">
                  Organism ({organism?.name})
                </th>
              </thead>
              <tbody>
                {organism.sensitivity.map((sensitivity, index) => (
                  <tr key={index} className="">
                    <td className="border text-[0.875rem] p-4 text-[#0C4654] font-[500]">
                      {sensitivity?.antibiotic}
                    </td>
                    <td className="border text-[0.875rem] p-4 text-[#0C4654] font-[500]">
                      {sensitivity?.reaction}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </tr>
  );
};

export default CultureResult;
